module.exports = __webpack_public_path__ + "img/21.6bb2693e.jpg";